import { render, staticRenderFns } from "./CossaVersion.vue?vue&type=template&id=cc6de2b0"
import script from "./CossaVersion.vue?vue&type=script&lang=js"
export * from "./CossaVersion.vue?vue&type=script&lang=js"
import style0 from "./CossaVersion.vue?vue&type=style&index=0&id=cc6de2b0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports